export const userRoles = [
    'Outside Sales-DFW','Outside Sales-HOU','Outside Sales-AUS',
    'Outside Sales-SAN','3G Renewal User', 'OnIt Home User', 'Authorized Partner Program'
];
